/**
 * pedagogicoBuilder — Atividades (assignment) + Fórum (comunicacao).
 *
 * @since H.2 (pedagógico novo)
 */
import type { $Fetch } from 'ofetch';

import { HttpAssignmentGateway } from '@/infrastructure/http/HttpAssignmentGateway';
import { HttpForumGateway } from '@/infrastructure/http/HttpForumGateway';
import {
  ListAssignments, CreateAssignment, UpdateAssignment, PublishAssignment,
  EncerrarAssignment, ArquivarAssignment, ListAssignmentSubmissions, CorrigirSubmission,
  DownloadSubmissionArquivo,
} from '@/application/usecase/AssignmentUseCaseImpl';
import {
  ListForumTopicos, CreateForumTopico, UpdateForumTopico, EncerrarForumTopico,
  ArquivarForumTopico, ListForumRespostas, CorrigirForumResposta,
} from '@/application/usecase/ForumUseCaseImpl';

export function buildPedagogicoSlice(httpClient: $Fetch) {
  const assignmentGateway = new HttpAssignmentGateway(httpClient);
  const forumGateway = new HttpForumGateway(httpClient);

  const useCases = {
    listAssignments: new ListAssignments(assignmentGateway),
    createAssignment: new CreateAssignment(assignmentGateway),
    updateAssignment: new UpdateAssignment(assignmentGateway),
    publishAssignment: new PublishAssignment(assignmentGateway),
    encerrarAssignment: new EncerrarAssignment(assignmentGateway),
    arquivarAssignment: new ArquivarAssignment(assignmentGateway),
    listAssignmentSubmissions: new ListAssignmentSubmissions(assignmentGateway),
    corrigirSubmission: new CorrigirSubmission(assignmentGateway),
    downloadSubmissionArquivo: new DownloadSubmissionArquivo(assignmentGateway),
    listForumTopicos: new ListForumTopicos(forumGateway),
    createForumTopico: new CreateForumTopico(forumGateway),
    updateForumTopico: new UpdateForumTopico(forumGateway),
    encerrarForumTopico: new EncerrarForumTopico(forumGateway),
    arquivarForumTopico: new ArquivarForumTopico(forumGateway),
    listForumRespostas: new ListForumRespostas(forumGateway),
    corrigirForumResposta: new CorrigirForumResposta(forumGateway),
  };

  return { useCases };
}
